const Authentication = [
  {
    path: '/auth',
    name: 'authentication',
    component: () => import(/* webpackChunkName: "auth" */'./authentication.vue'),
    meta: {
      requiresAuth: false,
    },
    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import(/* webpackChunkName: "login" */'./components/login.vue'),
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: 'forget_password',
        name: 'forget_password',
        component: () => import(/* webpackChunkName: "forgot_password" */'./components/forgot_password.vue'),
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: 'change_password',
        name: 'change_password',
        component: () => import(/* webpackChunkName: "forgot_password" */'./components/change_password.vue'),
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: 'password_reset/:token',
        name: 'password_reset',
        component: () => import(/* webpackChunkName: "forgot_password" */'./components/password_reset.vue'),
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
];

export default Authentication;
